export const appConfigs = {
  apiUrl: process.env.REACT_APP_API_URL,
};
